import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import FontAwesome from 'react-fontawesome';

import { Visible } from 'js/portfolio/components/visible';
import { Unibrow } from 'js/portfolio/components/unibrow';

const BannerButton = ({ children, ...props }) => (
  <Button bsSize="xs" className="unibrow-button" {...props}>
    <span className="unibrow-button-text">{children}</span>
    <i className="fa fa-caret-right unibrow-button-icon" />
  </Button>
);

class Countdown extends Component {
  constructor(props) {
    super(props);

    const startEpochSeconds = this.getCurrentEpochSeconds();
    this.state = {
      startEpochSeconds: startEpochSeconds,
      currentEpochSeconds: startEpochSeconds,
    };
  }

  componentWillMount() {
    this.interval = setInterval(() => {
      this.setState({ currentEpochSeconds: this.getCurrentEpochSeconds() });
    }, 250);
  }

  componentWillUnmount() {
    this.interval.clearInterval();
  }

  render() {
    return <span>{this.formatTime(this.secondsRemaining())}</span>;
  }

  formatTime(seconds) {
    if (seconds < 0) {
      return '0:00';
    }

    const minutesString = Math.floor(seconds / 60).toFixed(0);
    const secondsString = this.padTwoZeros(Math.round(seconds % 60).toFixed(0));
    return minutesString + ':' + secondsString;
  }

  padTwoZeros(string) {
    if (string.length === 0) {
      return '00';
    } else if (string.length === 1) {
      return '0' + string;
    } else {
      return string;
    }
  }

  secondsRemaining() {
    const secondsElapsed =
      this.state.currentEpochSeconds - this.state.startEpochSeconds;
    return this.props.seconds - secondsElapsed;
  }

  getCurrentEpochSeconds() {
    return Math.round(new Date().getTime() / 1000);
  }
}

class Header extends Component {
  upgradeUrl() {
    return (
      '/upgrade' +
      '?feature=portfolio' +
      '&show_payment=true' +
      '&provided_picture=' +
      this.props.providedPicture +
      '&btv=portfolio_ends_funnel'
    );
  }

  render() {
    const { props } = this;

    return (
      <div>
        <Visible modes={1}>
          <div>
            <Unibrow
              leftContent={
                <a href={props.profileUrl}>
                  <FontAwesome name="angle-left" />
                </a>
              }
            >
              <span>
                <span>
                  Review what your Personal Website will look like below.
                </span>
                <span>&nbsp;</span>
                <BannerButton onClick={this.setActiveAndGo}>
                  Activate Now
                </BannerButton>
              </span>
            </Unibrow>
          </div>
        </Visible>

        <Visible modes={2}>
          <div>
            <Unibrow
              leftContent={
                <a href={props.profileUrl}>
                  <FontAwesome name="angle-left" />
                </a>
              }
            >
              <span>
                <span>Activate your Personal Website now.</span>
                <span>
                  <BannerButton href={this.upgradeUrl()}>Publish</BannerButton>
                </span>
              </span>
            </Unibrow>
          </div>
        </Visible>

        <Visible modes={[3, 4]}>{this.renderLongFunnel()}</Visible>
      </div>
    );
  }

  renderLongFunnel() {
    return (
      <div className="DesignSystem">
        <div className="PortfolioLongFunnelHeader">
          {/* This pushDownContent div is here to push the main content of the
              page down so it doesn't overlap with the header. */}
          <div className="PortfolioLongFunnelHeader--pushDownContent" />

          <div className="PortfolioLongFunnelHeader--header">
            <div className="PortfolioLongFunnelHeader--leftContainer">
              <span className="PortfolioLongFunnelHeader--countdown">
                {this.renderLongFunnelLeftContainer()}
              </span>
            </div>
            <div className="PortfolioLongFunnelHeader--rightContainer">
              <div className="PortfolioLongFunnelHeader--publishButton">
                <Visible modes={3}>
                  <a href={this.upgradeUrl()}>
                    <button>{this.renderPurchaseButtonText()}</button>
                  </a>
                </Visible>
                <Visible modes={4}>
                  <a onClick={this.setActiveAndGo}>
                    <button>{'Activate Your Website ▸'}</button>
                  </a>
                </Visible>
              </div>

              <div className="PortfolioLongFunnelHeader--editButton">
                <a href="/portfolio_creation/photo">Edit</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderLongFunnelLeftContainer() {
    if (this.props.appliesTimePressure) {
      return (
        <div>
          <i className="fa fa-exclamation-triangle u-tcOrange u-pr2x" />
          Your preview will expire in <Countdown seconds={10 * 60} />
        </div>
      );
    } else {
      return <div>Preview only. Your website is not live.</div>;
    }
  }

  renderPurchaseButtonText() {
    return 'Purchase Your Website ▸';
  }

  setActiveAndGo = () => {
    const token = $('meta[name="csrf-token"]').attr('content');
    $.ajax({
      url: '/v0/settings/mark_active?subdomain_param=api',
      type: 'POST',
      dataType: 'json',
      data: {
        setting: {
          active: true,
        },
      },
      beforeSend: (xhr) => {
        xhr.setRequestHeader('X-CSRF-Token', token);
      },
    }).done((data) => {
      let href;
      if (data.subdomain) {
        href = `https://${data.subdomain}.${$app_host}?prem_fnl_first=true`;
      } else {
        href = 'settings#academia-websites';
      }
      window.location.href = href;
    });
  };
}

const mapStateToProps = ({ user_info }, ownProps) => {
  return {
    profileUrl: user_info.profile_url,
    providedPicture: ownProps.providedPicture,
  };
};
export default connect(mapStateToProps)(Header);
